<template>
  <qc-container title="平台流水">
    <page-request ref="table"
                  @load="loadSum"
                  :url="type===0?'/api/business/shop/income/platformMoneyLog':'/api/mgr/business/shop/money/log/list'" :table-header="type===0?tableHeader:tableHeader1" :expend="expend" :hide-op="true">
        <div class="flex flex-ac">
          <export-excel @action="addExportTask" ref="exportExcel" task-name="平台流水" task-key="orgFinance" file-name="money-log.xlsx" title="批量导出" button-name="批量导出" ></export-excel>
          <span class="messageAlert">共{{ total }}笔</span>
          <span class="messageAlert">|</span>
          <span class="messageAlert">收入{{sumData.incomeMoney.toFixed(2)}}元</span>
          <span class="messageAlert">支出{{sumData.outMoney.toFixed(2)}}元</span>
          <span class="messageAlert">待入账金额{{sumData.waitMoney.toFixed(2)}}元</span>
          <span class="messageAlert">现锁定押金{{sumData.depositMoney.toFixed(2)}}元</span>
          <span class="messageAlert">已退款押金{{sumData.refundDepositMoney.toFixed(2)}}元</span>
        </div>
    </page-request>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import TButton from "@/components/el/t-button.vue";
import PageRequest from "@/components/base/page-request.vue";
import BButton from "@/components/el/b-button.vue";
import ExportExcel from "@/components/base/ExportExcel.vue";

export default {
  props:{
    //0平台 1加盟商
    type:{
      type:Number,
      default:0
    }
  },
  name: "money-log",
  components: {ExportExcel, BButton, PageRequest, TButton, QcContainer},
  data() {
    return {
      tableHeader: [
        {prop: "createTime", label: "日期",width:160},
        {prop: "money", label: "收支金额",width:100},
        {prop: "remainder", label: "平台余额",width:100},
        {label: "收支类型",renderDraw:row=>{
            return row.salesType?"支出":"收入";
          },width: 100},
        {prop: "code", label: "流水号",width:200},
        {prop: "refCode", label: "关联订单",width:200,expend:true},
        {prop: "shopAccount", label: "商家账号",width:100,expend:true},
        {prop: "shopName", label: "商家名称",width:100,expend:true},
        {label: "备注",prop:"typeDesc"},
      ],
      tableHeader1: [
        {prop: "createTime", label: "日期",width:160},
        {prop: "money", label: "收支金额",width:100},
        {prop: "remainder", label: "平台余额",width:100},
        {label: "收支类型",renderDraw:row=>{
            return row.salesType?"支出":"收入";
          },width: 100},
        {prop: "code", label: "流水号",width:200},
        {prop: "refCode", label: "关联订单",width:200,expend:true},
        {label: "备注",prop:"typeDesc"},
      ],
      expend: [
        {label: "收支类型", prop: "salesType",type:"select",options:[{"label":"收入","value":"0"},{"label":"支出","value":"1"}]},
        {label: "日期", start: "startTime", end: "endTime", type: "daterange"},
      ],
      sumData:{incomeMoney:0,outMoney:0,waitMoney:0,depositMoney:0,refundDepositMoney:0},
      total:0,
    }
  },
  mixins: [tableBase],
  methods: {
    loadSum(searchObj,data){
      this.total = data.totalRecord;
      let url  = this.type===0?'/api/business/shop/income/platformMoneyLogSum':'/api/mgr/business/shop/money/log/moneyLogSum';
      this.simplePost(url,searchObj,res=>{
        this.sumData = res.data;
      })
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
